import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import { Button, Popup, TextBox } from "devextreme-react";
const ResetPassword = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [resetPasswordRequest, setResetPasswordRequest] = useState({
    // oldPassword: "",
    newPassword: "",
    // confirmPassword: "",
  });
  const [resetPwdError, setResetPwdError] = useState(false);
  const { openResetPasswordDialog, setResetPasswordDialog, userInfo } = props;
  const onInputChange = (e) => {
    setResetPasswordRequest({
      ...resetPasswordRequest,
      ['newPassword']: e.value,
    });
    if (e.value.length > 0) {
      setResetPwdError(false);
    }
  };
  const resetPasswordCallBack = () => {
    let resetPasswordObject = {
      userId: userInfo.id,
      newPassword: resetPasswordRequest.newPassword
    }
    axios
      .post(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.ResetPassword}`,
        resetPasswordObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      ).then(res => {
        console.log(res, 'reset password reponse');
        if (res.data === true) {
          setResetPasswordDialog(false);
          setResetPasswordRequest({
            newPassword: ""
          });
        }
      }).catch(err => {
        console.log(err)
      })
  }
  const resetPassword = (e) => {
    e.preventDefault();
    if (resetPasswordRequest.newPassword === "") {
      setResetPwdError(true);
    } else {
      resetPasswordCallBack();
    }

  };
  return (
    <div>
      <Popup
        visible={openResetPasswordDialog}
        onHiding={() => setResetPasswordDialog(false)}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title='Reset Password'
        container="#root"
        height='auto'
        width='auto'
      >
        <form onSubmit={(e) => resetPassword(e)}>
          <div className="row">
            <div className="col-md-12">
              <TextBox
                id="email"
                label="Enter New Password"
                labelMode="static"
                stylingMode='outlined'
                name="newPassword"
                mode="Password"
                value={resetPasswordRequest.newPassword}
                onValueChanged={(e) => onInputChange(e)}
              />
              {
                resetPwdError ? <span style={{ color: "red" }}>Password is Required</span> : null
              }
            </div>

            <div className="row">
              <div className="col-md-12" style={{ marginTop: "12px" }}>
                <Button
                  text="Save"
                  type="default"
                  useSubmitBehavior={true}
                />
                <Button
                  style={{ marginLeft: "12px" }}
                  text="Reset"
                  onClick={() => {
                    setResetPasswordRequest({
                      newPassword: ""
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </Popup>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ResetPassword);

